import(/* webpackMode: "eager" */ "/hisea-ssr/src/app/(app)/military-discounts/loading.js");
